"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(summ) {
  var withCents = parseFloat("".concat(Math.round(summ))).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ").replace('.', ',');
  return withCents.substr(0, withCents.indexOf(","));
}